import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement & { open: boolean }> {
  openFromCommand(event: Event & { command: string }) {
    if (event.command !== "show-modal" || event.defaultPrevented) return

    // Opening through the wrapper avoids Tailwind's duplicate native open on iOS 16.
    event.preventDefault()
    this.open()
  }

  open() {
    this.element.open = true
  }

  close() {
    this.element.open = false
  }
}
